'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editDir = exports.removeDir = exports.createDir = exports.createSubDir = exports.listDirs = exports.listSubDirs = undefined;

var _actions = require('../utils/actions');

var listSubDirs = exports.listSubDirs = function listSubDirs(parentDirId, query) {
  return {
    args: { parentDirId: parentDirId, query: query },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('listSubDirs'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.get(_actions.apiPrefix + '/dir/' + userId + '/' + parentDirId + '/subDir', {
        q: query,
        resType: 'json'
      });
    }
  };
};

// With parentDirId: 0
var listDirs = exports.listDirs = function listDirs(query) {
  return {
    args: { query: query },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('listDirs'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.get(_actions.apiPrefix + '/dir/' + userId + '/0/subDir', {
        q: query,
        resType: 'json'
      });
    }
  };
};

var createSubDir = exports.createSubDir = function createSubDir(parentDirId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    args: { parentDirId: parentDirId, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createSubDir'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.post(_actions.apiPrefix + '/dir/' + userId + '/' + parentDirId + '/createDir', {
        body: data,
        resType: 'json'
      });
    }
  };
};

// With parentDirId: 0
var createDir = exports.createDir = function createDir() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    args: { data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createDir'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.post(_actions.apiPrefix + '/dir/' + userId + '/0/createDir', {
        body: data,
        resType: 'json'
      });
    }
  };
};

var removeDir = exports.removeDir = function removeDir(dirId) {
  return {
    args: { dirId: dirId },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('removeDir'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.delete(_actions.apiPrefix + '/dir/' + userId + '/' + dirId, {
        resType: 'json'
      });
    }
  };
};

var editDir = exports.editDir = function editDir(dirId, data) {
  return {
    args: { dirId: dirId, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('editDir'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.patch(_actions.apiPrefix + '/dir/' + userId + '/' + dirId, {
        body: data,
        resType: 'json'
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/dir.js
// module id = 507
// module chunks = 1